import { Button } from "components/button";

export default function StoreFormContainer({
  children,
  submitLabel,
  onSubmit = () => {},
  submitParams,
  submitHref,
  onSecondary = () => {},
  secondaryLabel,
  secondaryHref,
  secondaryParams,
  submitDisabled = false,
  secondaryDisabled = false,
}) {
  return (
    <form
      className="h-[calc(100vh-81px)] flex flex-col justify-between overflow-auto"
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <div className="flex flex-col px-6">{children}</div>
      <div className={`flex justify-between p-8 ${!secondaryLabel && "ml-auto"}`}>  
        {secondaryLabel && (
          <Button
            variant="secondary"
            href={secondaryHref}
            type="button"
            disabled={secondaryDisabled}
            onClick={onSecondary}
            queryParams={secondaryParams}
          >
            {secondaryLabel}
          </Button>
        )}
        {submitLabel && (
          <Button
            disabled={submitDisabled}
            href={submitHref}
            type="submit"
            onClick={onSubmit}
            queryParams={submitParams}
          >
            {submitLabel}
          </Button>
        )}
      </div>
    </form>
  );
}
